/**
 * AutoCount - Sales Report Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function ReportsSales(): JSX.Element {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          {/* Summary Cards */}
          <Grid item xs={12} md={3}>
            <Card>
              <MDBox p={3} textAlign="center">
                <MDTypography variant="h3" color="success">$1,074</MDTypography>
                <MDTypography variant="body2" color="text">Total Sales (MTD)</MDTypography>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card>
              <MDBox p={3} textAlign="center">
                <MDTypography variant="h3" color="info">3</MDTypography>
                <MDTypography variant="body2" color="text">Orders (MTD)</MDTypography>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card>
              <MDBox p={3} textAlign="center">
                <MDTypography variant="h3">$358.08</MDTypography>
                <MDTypography variant="body2" color="text">Average Order Value</MDTypography>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card>
              <MDBox p={3} textAlign="center">
                <MDTypography variant="h3" color="warning">28%</MDTypography>
                <MDTypography variant="body2" color="text">Gross Margin</MDTypography>
              </MDBox>
            </Card>
          </Grid>

          {/* Report Options */}
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Sales Reports
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <Card variant="outlined">
                      <MDBox p={3}>
                        <MDTypography variant="h6" mb={1}>Sales Summary</MDTypography>
                        <MDTypography variant="body2" color="text" mb={2}>
                          Overview of sales by period, category, and customer.
                        </MDTypography>
                        <MDButton variant="gradient" color="success" size="small">Generate</MDButton>
                      </MDBox>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Card variant="outlined">
                      <MDBox p={3}>
                        <MDTypography variant="h6" mb={1}>Top Selling Parts</MDTypography>
                        <MDTypography variant="body2" color="text" mb={2}>
                          Most popular parts by quantity and revenue.
                        </MDTypography>
                        <MDButton variant="gradient" color="info" size="small">Generate</MDButton>
                      </MDBox>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Card variant="outlined">
                      <MDBox p={3}>
                        <MDTypography variant="h6" mb={1}>Customer Report</MDTypography>
                        <MDTypography variant="body2" color="text" mb={2}>
                          Customer purchase history and top buyers.
                        </MDTypography>
                        <MDButton variant="gradient" color="secondary" size="small">Generate</MDButton>
                      </MDBox>
                    </Card>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ReportsSales;
